/**
 * @fileoverview
 * Loading Interceptor - Manages global loading state
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../../http/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Skip loading for certain URLs (like background refreshes, conversation actions, and image URL fetch)
  const skipUrls = [
    '/auth/refresh',
    '/conversations',
    '/send-back',
    '/mark-resolved',
    '/save-draft',
    '/submit-response',
    '/audit/images', // Image URL fetch shows loading on the View button instead
  ];
  const shouldSkip = skipUrls.some(url => req.url.includes(url));

  if (!shouldSkip) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!shouldSkip) {
        loadingService.hide();
      }
    })
  );
};

